import React from 'react'
import NouiSliders from './NouiSlider';
import ColorScheme from './ColorScheme';
import { Container } from 'reactstrap';
import Breadcrumb from 'src/components/Common/Breadcrumb';

const RangeSlider = () => {
    document.title = "Range Slider | NGK Tours";
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid={true}>
                    <Breadcrumb title="Components" breadcrumbItem="Range Slider" />
                    <NouiSliders />
                    <ColorScheme />
                </Container>
            </div>
        </React.Fragment>
    )
}

export default RangeSlider